export default () => ({
  cartModal: false,
  cart: [],
  oldOrder: null,
});
